import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WebFamTag, WebFamTagPersons } from '../models/tag.model';

/**
 * Tagi profili - swobodne etykiety ("powstaniec", "emigracja do USA").
 * Słownik jest wspólny dla drzewa, więc kliknięcie w tag na profilu znajduje
 * wszystkich oznaczonych tą samą etykietą.
 */
@Injectable()
export class TagService {

    constructor(private httpClient: HttpClient) { }

    /** Słownik tagów drzewa z licznikiem osób - do podpowiedzi. */
    getTags(treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.get<WebFamTag[]>(environment.backendUrl + '/tag/list/tree/' + tree);
    }

    /** Tagi jednej osoby. */
    getPersonTags(personId: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.get<WebFamTag[]>(
            environment.backendUrl + '/tag/person/tree/' + tree + '/person/' + personId
        );
    }

    /** Osoby z danym tagiem. */
    getTagPersons(tagId: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.get<WebFamTagPersons>(
            environment.backendUrl + '/tag/persons/tree/' + tree + '/tag/' + tagId
        );
    }

    /** Przypięcie tagu; nieznaną nazwę backend zakłada w locie. */
    addPersonTag(personId: string, name: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.post<WebFamTag & { status: string }>(
            environment.backendUrl + '/tag/assign/tree/' + tree + '/person/' + personId, { data: { name } }
        );
    }

    /** Odpięcie tagu od osoby. */
    removePersonTag(personId: string, tagId: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.delete<{ status: string }>(
            environment.backendUrl + '/tag/assign/tree/' + tree + '/person/' + personId + '/tag/' + tagId
        );
    }
}
